import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { LazyGuideModal } from './LazyModals';
import { Sparkle } from './Sparkle';
export function Hero() {
  const [guideOpen, setGuideOpen] = useState(false);

  // Auf Desktop bleibt die Einblend-Animation erhalten; auf Handys erscheinen
  // Überschrift und Bild sofort, damit der Ladewert (LCP) nicht verzögert wird.
  const [animate] = useState(() => typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches);
  const fadeUp = (y: number, delay = 0) => animate ? {
    initial: {
      opacity: 0,
      y
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.5,
      delay,
      ease: 'easeOut' as const
    }
  } : {};
  const fadeX = (x: number, delay = 0) => animate ? {
    initial: {
      opacity: 0,
      x
    },
    animate: {
      opacity: 1,
      x: 0
    },
    transition: {
      duration: 0.5,
      delay,
      ease: 'easeOut' as const
    }
  } : {};
  return <section id="start" className="relative w-full px-4 pb-0 pt-10 sm:px-6 sm:pt-12" data-id="element-304" data-mp="3j9alrqbghebh">
      <div className="mx-auto grid max-w-[1300px] items-end gap-8 lg:grid-cols-[2.6fr_1fr] lg:gap-2 xl:grid-cols-[1.75fr_1fr] xl:gap-4" data-id="element-305" data-mp="3o73pmcpadw8l">
        <div className="flex h-full flex-col justify-center pb-0 pt-2 text-center sm:pt-2 lg:pb-16 lg:pt-0 lg:pl-0 xl:pl-12 xl:text-left" data-id="element-306" data-mp="3e9fpt8ctpyjk">
          <div className="relative block w-full self-center lg:w-[136%] lg:self-start xl:w-full" data-id="element-307" data-mp="30gzu6sm952so">
            <Sparkle className="animate-sparkle left-3 -top-5 h-5 w-5 sm:-left-2 sm:-top-3 sm:h-6 sm:w-6 md:hidden lg:block lg:-left-6 lg:-top-6 lg:h-8 lg:w-8" data-id="element-308" data-mp="359syxghq0b4r" />
            <Sparkle className="animate-sparkle-delayed -bottom-1 -right-1 h-4 w-4 sm:-bottom-2 sm:-right-4 sm:h-5 sm:w-5 md:bottom-1 md:left-[39%] md:right-auto lg:-bottom-3 lg:left-auto lg:-right-7" data-id="element-309" data-mp="2viy4houbm588" />
            <motion.h1 {...fadeUp(16)} className="font-display text-gold-3d mt-0 text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl md:text-justify lg:text-4xl lg:text-justify xl:text-justify" data-id="element-310" data-mp="2lkin4dl3iabx">
              Verdiene 10.000€+ monatlich als Hot Sales Girl, selbst wenn du noch nie verkauft hast –
              ohne Social Media Reichweite &amp; ohne eigenes Produkt
            </motion.h1>
          </div>

          <p className="mx-auto mt-5 max-w-full text-[15px] leading-relaxed text-white sm:text-base lg:mx-0 lg:pr-10 lg:text-left" data-id="element-311" data-mp="deyke41ik3c4">
            <span className="block font-semibold uppercase tracking-wide" data-id="element-312" data-mp="161t1qs31amld">
              Raus aus dem 9-to-5-Hamsterrad.
            </span>
            <span className="mt-3 block" data-id="element-313" data-mp="111omt6hrxzx9">
              In nur 8 Wochen zeigen wir dir, wie du als Hot Sales Girl ortsunabhängig arbeiten
              und dir mit deinen Sales-Skills ein attraktives Einkommen aufbauen kannst.
            </span>
            <span className="mt-3 block" data-id="element-314" data-mp="3lqm2jypo95ux">
              Lerne, authentisch und ohne Druck zu verkaufen, hochpreisige Angebote sicher
              abzuschließen und dabei 500–1.500€ Provision pro Abschluss zu verdienen – auch ohne
              Vorkenntnisse.
            </span>
          </p>

          <div className="relative mx-auto mt-8 self-center lg:mx-0 lg:translate-y-4 lg:self-start xl:translate-y-0" data-id="element-315" data-mp="218tq5wogtcfe">
            <Sparkle className="animate-sparkle-fast -bottom-3 -right-4 h-6 w-6" data-id="element-316" data-mp="2b0pnh5iq8yik" />
            <button type="button" onClick={() => setGuideOpen(true)} className="btn-gold-shiny inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-317" data-mp="2b2k9yo9ncyor">
              Guide kostenlos sichern
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-318" data-mp="2p10fibvrwj5b" />
            </button>
          </div>
        </div>

        <div className="relative flex items-end justify-center self-end lg:justify-end" data-id="element-319" data-mp="2txhe600lmfwn">
          <picture className="contents" data-id="element-320" data-mp="uoal7t1ht7xe">
            <source media="(max-width: 639px)" srcSet="https://cdn.magicpatterns.com/uploads/8ix4ZMEKvfB9n38z1Ya4VS/premium-closerin-werden-hot-sales-girls-academy.mobile.webp" type="image/webp" data-id="element-321" data-mp="zlaoxxavdylc" />
          <motion.img {...fadeUp(30, 0.15)} src="https://cdn.magicpatterns.com/uploads/w2xwVneUjqSfENHkrW3TJ4/premium-closerin-werden-hot-sales-girls-academy.webp" alt="Hot Sales Girl werden: Tina Xla von der Hot Sales Girls Academy" fetchPriority="high" decoding="async" className="block w-[88%] max-w-sm translate-x-8 object-contain sm:w-[75%] sm:max-w-sm sm:translate-x-12 md:w-[70%] md:max-w-md md:translate-x-16 lg:w-[95%] lg:max-w-lg lg:-translate-x-12 xl:w-[80%] xl:max-w-xl xl:-translate-x-16" data-id="element-322" data-mp="3vh5jg58rl46o" />
          </picture>

          <ul className="pointer-events-none absolute inset-0 lg:-translate-x-3 xl:-translate-x-2" data-id="element-323" data-mp="3mo2dei0g7tm2">
            <motion.li {...fadeX(-16, 0.35)} className="absolute left-[3%] top-[46%] rounded-full border border-hot-600 bg-hot-600/25 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 sm:left-[1%] sm:bg-hot-600/15 sm:text-xs sm:backdrop-blur-sm md:left-[22%] lg:left-[-28%] lg:top-[56%] xl:left-[8%] xl:top-[58%]" data-id="element-324" data-mp="2yxybqg6tm3xp">
              ✓ 100% Ortsunabhängig
            </motion.li>
            <motion.li {...fadeX(16, 0.45)} className="absolute right-[7%] top-[62%] rounded-full border border-hot-600 bg-hot-600/25 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 sm:right-[21%] sm:bg-hot-600/15 sm:text-xs sm:backdrop-blur-sm md:right-[26%] lg:right-[-6%] lg:top-[68%] xl:right-[12%] xl:top-[70%]" data-id="element-325" data-mp="14isug5sysfi9">
              ✓ Freie Zeiteinteilung
            </motion.li>
            <motion.li {...fadeX(-16, 0.55)} className="absolute bottom-[10%] left-[2%] rounded-full border border-hot-600 bg-hot-600/25 px-3 py-1 text-[10px] font-semibold tracking-wide text-white shadow-lg shadow-hot-600/30 sm:left-[5%] sm:bg-hot-600/15 sm:text-xs sm:backdrop-blur-sm md:left-[20%] lg:left-[-21%] lg:bottom-[12%] xl:left-[7%] xl:bottom-[14%]" data-id="element-326" data-mp="1nbws029azci5">
              ✓ Ohne Vorkenntnisse
            </motion.li>
          </ul>
        </div>
      </div>

      <LazyGuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-327" data-mp="24peh1ilqr9ny" />
    </section>;
}